import React from 'react';
import { useSelector } from 'react-redux';
import { logoAdsAppOrigin } from '../../../constants/appOrigin';
import { Div, StyledImage, StyledLogo } from './styled';
import ImageAds from '../../../assets/images/login/wisenroll.webp';
import ImageAds2 from '../../../assets/images/login/wisenroll-lendecy-blue.webp'
import { envSetting } from '../../../constants/envSetting';

/**
 * Ads component with structure, image and logo
 * @component
 * @returns
 */
export const Ads = () => {
  const { selectedProduct } = useSelector(state => state.user);
  const isLendency = envSetting?.isLendency
  const srcImg = (isLendency === 'true') ? ImageAds2 : ImageAds


  return (
    <Div>
      {ImageAds && (
        <StyledImage src={ srcImg } 
          lendency={isLendency}
        />

      )}
      <StyledLogo
        src={ (selectedProduct) ? selectedProduct?.image_ads || logoAdsAppOrigin.default : logoAdsAppOrigin.default }
      />
    </Div>
  );
};